import React from 'react'
import PropTypes from 'prop-types'
import { SL_GATE } from 'Defaults/modals'
import useRequiresTermsOfUseAgreement from 'Hooks/useCheckTermsOfUse'
import ListingListViewContent from 'Components/ListingListViewContent'
import { _ListContentContainer } from './styles'

const ListingList = ({
  listings,
  userIsAuthentificated,
  googleAnalyticsEvent,
  mode,
  isBc,
  winWidth,
  loginHandler,
  signupHandler,
  multiListings,
}) => (
  listings && listings.map((listing) => {
    const {
      requireTermsConditionAgreement,
      openTermsConditionModal,
      requireTermsEmailVerification,
      termsConditionRequiredId,
    } = useRequiresTermsOfUseAgreement({
      listingSource: listing?.source,
    })
    return (
      <_ListContentContainer key={listing.id} multiListings={multiListings}>
        <ListingListViewContent
          listing={listing}
          userIsAuthentificated={userIsAuthentificated}
          googleAnalyticsEvent={googleAnalyticsEvent}
          mode={mode}
          isBc={isBc}
          winWidth={winWidth}
          openLogin={() => {
            loginHandler({
              gate: SL_GATE.SEARCH_MARKER_LISTING_INFO,
              listing,
              termsConditionRequiredId,
            })
          }}
          signupOnImage={() => {
            signupHandler({
              gate: SL_GATE.SEARCH_MARKER_LISTING_IMAGE,
              listing,
              termsConditionRequiredId,
            })
          }}
          signupOnInfo={() => {
            signupHandler({
              gate: SL_GATE.SEARCH_MARKER_LISTING_INFO,
              listing,
              termsConditionRequiredId,
            })
          }}
          listViewStyle
          requireTermsConditionAgreement={requireTermsConditionAgreement}
          requireTermsEmailVerification={requireTermsEmailVerification}
          openTermsConditionModal={openTermsConditionModal}
          termsConditionRequiredId={termsConditionRequiredId}
          multiListings={multiListings}
        />
      </_ListContentContainer>
    )
  })
)

ListingList.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({})),
  userIsAuthentificated: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  mode: PropTypes.string,
  isBc: PropTypes.bool,
  winWidth: PropTypes.number,
  loginHandler: PropTypes.func,
  signupHandler: PropTypes.func,
  multiListings: PropTypes.bool,
}

export default ListingList

